import Vue from 'vue'
import { AclInstaller, AclCreate, AclRule } from 'vue-acl'
import router from '@/router'

Vue.use(AclInstaller)

let initialRole = 'administrator'

const userInfo = JSON.parse(localStorage.getItem('userInfo'))
// //console.log('ACL')
// //console.log(userInfo)
if (userInfo && userInfo.userRole) initialRole = userInfo.userRole.join(", ")
// //console.log(initialRole)
export default new AclCreate({
  initial  : initialRole,
  notfound : '/pages/not-authorized',
  router,
  acceptLocalRules : true,
  globalRules: {
    administrator  : new AclRule('administrator').generate(),
    user : new AclRule('user').or('payroll').or('hr').or("hrpayroll").or('manager').or('executive').or('administrator').generate(),
    payroll: new AclRule('payroll').or("hrpayroll").or('administrator').generate(),
    hr: new AclRule('hr').or("hrpayroll").or('executive').or('administrator').generate(),
    hrpayroll: new AclRule('executive').or('administrator').generate(),
    manager: new AclRule('manager').or("hrpayroll").or('executive').or('administrator').generate(),
    executive: new AclRule('executive').or('administrator').generate()

  }
})
